(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AsyncAF", [], factory);
	else if(typeof exports === 'object')
		exports["AsyncAF"] = factory();
	else
		root["AsyncAF"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 